module.exports = __webpack_public_path__ + "img/optin-2.429eee12.png";